import React from 'react';
import { X } from 'lucide-react';
import { supabase } from '../../lib/supabase';

interface ChallengeFormProps {
  onClose: () => void;
  onSuccess: () => void;
}

export function ChallengeForm({ onClose, onSuccess }: ChallengeFormProps) {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    try {
      const formData = new FormData(form);
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) throw new Error('Not authenticated');
      
      const data = {
        title: formData.get('title') as string,
        description: formData.get('description') as string,
        start_date: formData.get('startDate') as string,
        end_date: formData.get('endDate') as string,
        reward: formData.get('reward') as string,
        is_active: true,
        user_id: user.id
      };

      const { error } = await supabase
        .from('challenges')
        .insert(data);
      if (error) throw error;
      
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Error creating challenge:', error);
      alert('Failed to create challenge. Please try again.');
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-[#2A2B2E] rounded-3xl p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Create New Challenge</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-black/20 rounded-full"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-400 mb-1">Title</label>
            <input
              name="title"
              type="text"
              required
              className="w-full px-4 py-2 bg-black/20 rounded-xl text-white"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-400 mb-1">Description</label>
            <textarea
              name="description"
              required
              className="w-full px-4 py-2 bg-black/20 rounded-xl text-white h-32 resize-none"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-gray-400 mb-1">Start Date</label>
              <input
                name="startDate"
                type="datetime-local"
                required
                className="w-full px-4 py-2 bg-black/20 rounded-xl text-white"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-1">End Date</label>
              <input
                name="endDate"
                type="datetime-local"
                required
                className="w-full px-4 py-2 bg-black/20 rounded-xl text-white"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm text-gray-400 mb-1">Reward</label>
            <input
              name="reward"
              type="text"
              required
              className="w-full px-4 py-2 bg-black/20 rounded-xl text-white"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-[var(--accent-color)] text-black rounded-xl py-3 font-medium hover:opacity-90 transition-opacity"
          >
            Create Challenge
          </button>
        </form>
      </div>
    </div>
  );
}